import ContinueWatchingForm from './ContinueWatchingForm';

export default ContinueWatchingForm;
